import React, { Fragment } from "react";

export default function SampleCommentCounts({
  clientView,
  client_comment_count,
  internal_comment_count,
  internal_client_visible_comment_count,
  todo_count,
  lab_todo_count,
  client_todo_count,
  retested,
  handleShowRetests,
  handleShowComments,
  caveats_count,
}) {
  const showAddButton =
    (clientView &&
      client_comment_count == 0 &&
      internal_client_visible_comment_count == 0 &&
      client_todo_count == 0) ||
    (!clientView &&
      client_comment_count == 0 &&
      internal_comment_count == 0 &&
      lab_todo_count == 0);
  return (
    <span style={{ cursor: "pointer" }}>
      {retested && (
        <span className="label label-success" onClick={handleShowRetests}>
          RT
        </span>
      )}
      <span onClick={handleShowComments}>
        {client_comment_count > 0 && (
          <span className="label label-client-comment">{client_comment_count}</span>
        )}
        {!clientView &&
          internal_comment_count > 0 && (
            <span className="label label-lab-comment">{internal_comment_count}</span>
          )}
        {clientView &&
          internal_client_visible_comment_count > 0 && (
            <span className="label label-lab-comment">
              {internal_client_visible_comment_count}
            </span>
          )}
        {!clientView &&
          lab_todo_count > 0 && <span className=" label label-todo">{lab_todo_count}</span>}
        {clientView &&
          client_todo_count > 0 && (
            <span className="label label-todo">{client_todo_count}</span>
          )}
        {caveats_count > 0 && <span className="label label-caveat">{caveats_count}</span>}
        {showAddButton && (
          <span className="add-comment-button">
            &nbsp;&nbsp;
            <span className="fa fa-plus" />
            &nbsp;&nbsp;
          </span>
        )}
      </span>
    </span>
  );
}
